// contains old format for displaying validation failure
import APP_ERROR from '../constants/appErrors';

const getErr = APP_ERROR;

class HandleResponses {
  static Status(result) {
    let text = '';
    const status = result.status;
    const { code, data, message, field } = (result.data && result.data.errors) ? result.data.errors[0] : { };
    switch (status) {
      case 204:
        return { success: 'OK' };
      case 400:
        if (code && data && data.length) {
          text = getErr[code] + data.toString();
        } else if (code || field || message) {
          text = (code) ? getErr[code] : `${message} ${getErr.VALIDATION_FAILS}`;
        } else {
          text = getErr['400'];
        }
        return { error: text };

      case 401:
        return { error: getErr['401'] };

      case 426:
      case 409:
        return { error: message };

      case 403:
        return { error: message || getErr['403'] };

      case 404:
        return { error: getErr['404'] };

      case 500:
        return { error: getErr['500'] };

      case 503:
        return { error: getErr['503'] };
      case 504:
        return { error: getErr['504'] };

      default:
        return { response: getErr.GENERAL_ERR };
    }
  }
}

export default HandleResponses;
